<div class="p-inputgroup input-group size-dropdown-container">
  <input pInputText type="number" class="form-control form-control-sm" [(ngModel)]="size" (change)="handleSizeChange()"
    [disabled]="disableField">
  <div class="input-group-append">
    <p-select [options]="units" [(ngModel)]="unit" optionLabel="name" optionValue="code" (onChange)="handleUnitChange()"
      [ngClass]="{'property-pane-size-dropdown': (currentPage?.currentPage === 'templates' && !isTemplateFontGroup)}"
      [disabled]="disableField" appendTo="body"></p-select>
  </div>
</div>